import React, { useEffect } from "react";
import commonFunction from "../../Utils/commonFunction";
import { useState } from "react";
import parse from 'html-react-parser';
import Seo from "../../Seo/Seo";
import { webPageSchema } from "../../Seo/jsonld";
import { getRouteSeo } from "../../Seo/routeSeo";
import { demoteHeadings } from "../../Utils/html";
import "./Terms.css"
import { useTranslation } from "react-i18next";

function Terms() {

  const [pageData, setPageData] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0)
    const fetchPageData = async () => {
      try {
        // Was `commonFunction.getPagesByTitle(...)` — a function that did not
        // exist, so this page rendered with an empty body. The slug was also
        // derived from window.location.pathname; this component is only ever
        // mounted at /terms, so the constant is both simpler and prerender-safe.
        const response = await commonFunction.getPageByTitle("terms");
        setPageData(response);

      } catch (error) {
        console.error("Error fetching page:", error);
      }
    };

    fetchPageData();
  }, [])

  const seo = getRouteSeo("/terms");

  const { t } = useTranslation();

  return (
    <>
      <main className="terms-rich-content remove-space">
        <Seo
          type="article"
          jsonLd={[
            webPageSchema({
              title: seo?.title,
              description: seo?.description,
              url: "/terms",
            }),
          ]}
        />
        <section className="page-info-sec">
          <div
            className="bg-fixed wow fadeIn"
            data-wow-delay="0.1s"
            style={{ background: 'url("/assets/img/page-info1.png")' }}
          />
          <div
            className="bg-fixed img-overlay wow fadeIn"
            data-wow-delay="0.2s"
          />
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">
                <div
                  className="page-info-block wow fadeInUp"
                  data-wow-delay="0.3s"
                >
                  <h1>Vilkår og betingelser</h1>
                  <div className="btm-line-2 text-center justify-content-center">
                    <span />
                    <span />
                  </div>
                  <p>{t('common.TermsHeroSubtitle')}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* demoteHeadings: this page already has its own hero <h1>, so any
            <h1> an admin puts in the CMS body shifts to <h2>. */}
        {parse(demoteHeadings(pageData?.data?.page?.description || ''))}
      </main>
    </>
  );
}

export default Terms;
